export const GET_ALL_PROFORMA_FAILURE = 'GET_ALL_PROFORMA_FAILURE';
export const GET_ALL_PROFORMA_SUCCESS = 'GET_ALL_PROFORMA_SUCCESS';
